import { configureStore } from '@reduxjs/toolkit';
import { widget } from './reducer';

export const store = configureStore({
	reducer: widget,
});
